@if (popoverText) {
    <div
        [ngClass]="[placement, popoverType]" class="custom-popover d-flex arrow--2">
        <span>{{ popoverText | translate: {value: popoverTextParam} }}</span>
    </div>
}
